var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',{staticClass:"text-success"},[_vm._v(" ("),_vm._t("default",[_vm._v("automatycznie")]),_vm._v(") ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }